<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workDocsSchemeTypeGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
        sort-az="last_name"
      >
        <template v-slot:buttons>
          <WorkDocsSchemeTypeModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_scheme_types',
              })
            "
            :create="true"
          />
        </template>
        <WorkDocsSchemeTypeTable :items="workDocsSchemeTypeGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkDocsSchemeTypeTable from 'components/setting/workDocsSchemeType/WorkDocsSchemeTypeTable'
import WorkDocsSchemeTypeModal from 'components/setting/workDocsSchemeType/WorkDocsSchemeTypeModal'

export default {
  name: 'WorkDocsSchemeType',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkDocsSchemeTypeTable,
    WorkDocsSchemeTypeModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workDocsSchemeType', ['workDocsSchemeTypeGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workDocsSchemeType', ['onWorkDocsSchemeTypeGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkDocsSchemeTypeGrid(data)
    },
  },
}
</script>
